import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Container from '@material-ui/core/Container';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    display: 'flex',
  },
  cardImg: {
    height: 'auto',
    width: '100%',
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
  },
  cardActionArea: {
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  courtesy: {
    paddingLeft: '2em',
    textAlign: 'left',
    fontSize: '0.6667rem',
    float: 'left', 
    marginTop: '10em',
  }
});

const Home = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div style={{ paddingTop: '50px', paddingBottom: '100px' }}>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={4} className={classes.card}>
            <Card className={classes.root}>
              <CardActionArea
                onClick={() => {
                  history.push('/projects');
                }}
                className={classes.cardActionArea}
              >
                <CardMedia
                  alt="Projects"
                  title="Projects"
                >
                  <img
                    className={classes.cardImg}
                    src="/Knowledge_Management.jpg"
                    alt="Projects"
                  />
                </CardMedia>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    align="center"
                  >
                    Projects
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={4} className={classes.card}>
            <Card className={classes.root}>
              <CardActionArea
                onClick={() => {
                  history.push('/code-development');
                }}
                className={classes.cardActionArea}
              >
                <CardMedia
                  alt="Code Development"
                  title="Code Development"
                >
                  <img
                    className={classes.cardImg}
                    src="/Procurement.jpg"
                    alt="Code Development"
                  />
                </CardMedia>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    align="center"
                  >
                    Code Development
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={4} className={classes.card}>
            <Card className={classes.root}>
              <CardActionArea
                onClick={() => {
                  history.push('/references');
                }}
                className={classes.cardActionArea}
              >
                <CardMedia
                  alt="References"
                  title="References"
                >
                  <img
                    className={classes.cardImg}
                    src="/Travel.jpg"
                    alt="References"
                  />
                </CardMedia>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    align="center"
                  >
                    References
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={1} />
          <Grid item xs={5} className={classes.card}>
            <Card className={classes.root}>
              <CardActionArea
                onClick={() => {
                  history.push('/training');
                }}
                className={classes.cardActionArea}
              >
                <CardMedia alt="Training" title="Training">
                  <img
                    className={classes.cardImg}
                    src="/Training.jpg"
                    alt="Training"
                  />
                </CardMedia>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    align="center"
                  >
                    Training
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={5} className={classes.card}>
            <Card className={classes.root}>
              <CardActionArea
                onClick={() => {
                  // history.push('/under-construction');
                }}
                className={classes.cardActionArea}
              >
                <CardMedia alt="Under Construction" title="Under Construction">
                  <img
                    className={classes.cardImg}
                    src="/Actionable_Analytics_1_1.jpg"
                    alt="Under Construction"
                  />
                </CardMedia>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    align="center"
                  >
                    Under Construction
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <div className={classes.courtesy} >
            *photos courtesy of DOD*
      </div>
    </div>
  );
};

export default Home;
